<template>
	<a 
		:href="url" 
		aria-role="button" 
		:tabindex="tabindex" 
		@keydown.enter.prevent="followLink" 
		v-on:click.stop.prevent="followLink" 
		:class="[{'active': model && model.active}]">{{ text }}<span></span></a>
</template>

<script>
export default {
	props: ['model', 'href', 'index', 'tabindex', 'eventName'],
	computed: {
		actualTabindex() {
			return this.tabindex || 0;
		},
		url() {
			return (this.href) ? this.href : ((this.model !== null && typeof this.model !== 'undefined' && typeof this.model.url !== 'undefined') ? this.model.url : '#')
		},
		text() {
			return (this.model!==null) ? this.model.title : ''
		}
	},
	methods: {
		followLink(e) {
			var keyEvent = (e.type==='keydown');
			if (this.eventName) {
				this.$emit(this.eventName, { index: this.index, keyEvent: keyEvent });
			} else if (typeof this.model === 'undefined' || typeof this.model.children === 'undefined' || this.model.children.length == 0) {
				if (this.$route.params.slug===this.model.params.slug) {

					// When navigating back from .behind-red instead of triggering new focus it navigates to link

					this.$emit('closeMenu');
				} else {
					this.$router.push({
						name: this.model.name, 
						params: ((typeof this.model.params !== 'undefined') ? this.model.params : {})
					});
				}
			} else {
				this.$emit('showArticles', { 
					index: this.index, keyEvent: keyEvent
				});
			}
		}
	}
}
</script>